import {Locales} from '@netx/core-next/locales/utils/Locales';
import {VisualType} from './constants';

export const VisualTypeLabel: Record<VisualType, string> = Locales((i18n) => ({
	[VisualType.ASSET]: i18n('i18n.asset'),
	[VisualType.COLOR]: i18n('i18n.color'),
}));
